import { useState, useEffect } from "react";
import { ArrowDown } from "lucide-react";

interface ScrollIndicatorProps {
  targetId?: string;
  delay?: number;
}

export const ScrollIndicator = ({ 
  targetId = "services",
  delay = 2500 
}: ScrollIndicatorProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldHide, setShouldHide] = useState(false);

  useEffect(() => {
    const showTimer = setTimeout(() => {
      setIsVisible(true);
    }, delay);

    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShouldHide(true);
      } else {
        setShouldHide(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      clearTimeout(showTimer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [delay]);

  const handleClick = () => {
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div
      className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 cursor-pointer z-20 transition-opacity duration-500"
      style={{
        opacity: isVisible && !shouldHide ? 1 : 0,
        pointerEvents: isVisible && !shouldHide ? 'auto' : 'none'
      }}
      onClick={handleClick}
    >
      <p className="text-sm text-muted-foreground animate-pulse">
        Scroll to explore
      </p>
      <ArrowDown 
        className="w-6 h-6 text-primary animate-bounce" 
        style={{
          animation: 'bounce 2s ease-in-out infinite'
        }}
      />
    </div>
  );
};
